module.exports = __webpack_public_path__ + "media/images/Branding/HW Vertical 1-9a589636ad4aa7008c143e01e66cc420.png";